import React from "react";
import { Link } from "react-router-dom";

import { withTranslation } from 'react-i18next';

// react component for creating dynamic tables
import ReactTable from "react-table";
import SweetAlert from "react-bootstrap-sweetalert";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Slide from "@material-ui/core/Slide";
import Tooltip from "@material-ui/core/Tooltip";

// @material-ui/icons
import Assignment from "@material-ui/icons/AssignmentOutlined";
import Extension from "@material-ui/icons/ExtensionOutlined";
import Sync from "@material-ui/icons/SyncOutlined";
import Delete from "@material-ui/icons/DeleteOutline";

// core components
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import Snackbars from "components/Snackbar/Snackbar.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";

// Feathers
import { feathersClient } from "../../helpers/feathers";
import ga from "../../helpers/google-analytics";

// Styles
import groupsStyle from "assets/jss/material-dashboard-pro-react/views/groupsStyle";
import moment from "moment";

import defaults from "../../helpers/defaults";

function Transition(props) {
  return <Slide direction="down" {...props} />;
}

class Groups extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      alert: null,
      groups: [], //Ha de ser un array, si no el map no funciona
      groupOptionsDialog: false,
      groupOptions: {
        _id: "",
        name: ""
      },
      notification: {
        visible: false,
        text: "",
        color: "success"
      }
    };
  }

  componentDidMount() {
    this._isMounted = true;
    ga.pageview(window.location.pathname);
    feathersClient
      .service("groups")
      .find({ query: { $sort: { name: 1 } } })
      .then(groups => {
        groups.data.forEach(group => {
          this.addGroupLink(group);
          this.addGroupSyncStatus(group);
          this.addGroupActions(group);
        });
        if (this._isMounted)
          this.setState({
            groups: groups.data
          });
        feathersClient
          .service("groups")
          .on("created", group => this.addGroupEvent(group));
        feathersClient
          .service("groups")
          .on("patched", group => this.changeGroupOptionsEvent(group));
        feathersClient
          .service("groups")
          .on("removed", group => this.removeGroupEvent(group));
      })
      .catch(error => {
        this.showNotification(
          this.props.t('translation:error_fetching_groups') + ": " + error.name,
          "warning"
        );
        if (this._isMounted)
          this.setState({
            groups: []
          });
      });
  }

  componentWillUnmount() {
    this._isMounted = false;

    feathersClient.service("groups").removeAllListeners("created");
    feathersClient.service("groups").removeAllListeners("patched");
    feathersClient.service("groups").removeAllListeners("removed");
  }

  hideAlert() {
    if (this._isMounted)
      this.setState({
        alert: null
      });
  }

  deleteGroupWarning(group) {
    if (this._isMounted)
      this.setState({
        alert: (
          <SweetAlert
            warning
            style={{ display: "block", marginTop: "-200px" }}
            title={this.props.t('translation:are_you_sure')}
            onConfirm={() => this.removeGroup(group)}
            onCancel={() => this.hideAlert()}
            confirmBtnCssClass={
              this.props.classes.button + " " + this.props.classes.success
            }
            cancelBtnCssClass={
              this.props.classes.button + " " + this.props.classes.danger
            }
            confirmBtnText={this.props.t('translation:yes_delete_it')}
            cancelBtnText={this.props.t('translation:cancel')}
            showCancel
          >
            {this.props.t('translation:this_will_remove_the_group')}
          </SweetAlert>
        )
      });
  }

  removeGroupEvent(group) {
    var temp = [...this.state.groups];
    var index = temp.findIndex(x => x._id === group._id);
    if (index >= 0) {
      temp.splice(index, 1);
      if (this._isMounted)
        this.setState({
          groups: temp
        });
    }
  }

  removeGroup(group) {
    //event.preventDefault();
    this.hideAlert();
    feathersClient
      .service("groups")
      .remove(group._id)
      .then(message => {
        this.showNotification(this.props.t('translation:group_deleted_successfully'), "success");
        /*var temp = [...this.state.groups];
      var index = temp.indexOf(group);
      temp.splice(index, 1);
      if (this._isMounted) this.setState({
        groups: temp
      });*/
      })
      .catch(error => {
        this.showNotification(error.name + ": " + error.message, "warning");
      });
  }

  addNewGroupClick = event => {
    var temp = {
      _id: "", //Aquest és l'identificador del registre de la BBDD
      name: "" //Aquí hi va el nom del grup de la DDBB, no l'ID!!!
    };
    if (this._isMounted) this.setState({ groupOptions: temp });
    this.showGroupOptions(true);
  };

  changeGroupOptionsClick(group) {
    var temp = {
      _id: group._id, //Aquest és l'identificador del registre de la BBDD
      name: group.name //Aquí hi va el nom del grup de la DDBB, no l'ID!!!
    };
    if (this._isMounted) this.setState({ groupOptions: temp });
    this.showGroupOptions(true);
  }

  syncGroup(group) {
    feathersClient
      .service("groups")
      .patch(group._id, { synchronize: true })
      .then(group => {
        //validateGroup(group);
        //this.updateGroupUI(group);
        this.showNotification(this.props.t('translation:group_successfully_synchronized'), "success");
      })
      .catch(error => {
        this.showNotification(this.props.t('translation:error_synching_group') + ": " + error.name, "warning");
      });
  }

  syncAllGroups() {
    feathersClient
      .service("groups")
      .patch(null, { synchronize: true })
      .then(groups => {
        //validateGroup(group);
        //this.updateGroupUI(group);
        this.showNotification(this.props.t('translation:all_groups_synched_correctly'), "success");
      })
      .catch(error => {
        this.showNotification(
          this.props.t('translation:error_synching_groups') + ": " + error.name,
          "warning"
        );
      });
  }

  showNotification(message, color) {
    if (!this.state.notification["visible"]) {
      var x = this.state.notification;
      x["visible"] = true;
      x["text"] = message;
      x["color"] = color;
      if (this._isMounted) this.setState(x);
      // use this to make the notification autoclose
      setTimeout(
        function () {
          x["visible"] = false;
          if (this._isMounted) this.setState(x);
        }.bind(this),
        3000
      );
    }
  }

  showGroupOptions(show) {
    if (this._isMounted)
      this.setState({
        groupOptionsDialog: show
      });
  }

  handleGroupOptionChange(event, option) {
    var temp = this.state.groupOptions;
    temp[option] = event.target.value;
    if (this._isMounted)
      this.setState({
        groupOptions: temp
      });
  }

  applyGroupOptionsClick(options) {
    this.showGroupOptions(false);
    if (options._id === "") {
      this.addGroup(options);
    } else {
      this.changeGroupOptions(options);
    }
  }

  addGroupEvent(newGroup) {
    this.addGroupLink(newGroup);
    this.addGroupSyncStatus(newGroup);
    this.addGroupActions(newGroup);
    if (this._isMounted)
      this.setState({
        groups: [...this.state.groups, newGroup]
      });
  }

  addGroup(options) {
    feathersClient
      .service("groups")
      .create({
        name: options.name
      })
      .then(newGroup => {
        this.showNotification(this.props.t('translation:new_group_created_correctly'), "success");
        /*this.addGroupActions(newGroup);
      if (this._isMounted) this.setState({
        groups: [...this.state.groups, newGroup]
      });*/
      })
      .catch(error => {
        this.showNotification(this.props.t('translation:error') + ": " + error.name, "warning");
      });
  }

  addGroupLink(group) {
    const url = "groups/" + group._id;
    group.link = (
      <Link to={url} key={group.name}>
        {group.name}
      </Link>
    );
  }

  addGroupSyncStatus(group) {
    const synched = group.updatedAt === group.synchedAt;
    const dateString = moment(group.synchedAt).format(defaults.momentFormat);
    group.syncStatus = (
      <Tooltip
        disableFocusListener={true}
        id="tooltip-top"
        title={synched ? this.props.t('translation:synchronized') : this.props.t('translation:not_synchronized')}
        placement="top"
        classes={{ tooltip: this.props.classes.tooltip }}
        key={dateString}
      >
        <div style={{ color: synched ? "#4caf50" : "#ff9800" }}>
          {dateString}
        </div>
      </Tooltip>
    );
  }

  addGroupActions(group) {
    group.actions = (
      // we've added some custom button actions
      <div className="actions-right">
        {/* use this button to add a like kind of action */}
        <Tooltip
          disableFocusListener={true}
          id="tooltip-top"
          title={this.props.t('translation:synchronize')}
          placement="top"
          classes={{ tooltip: this.props.classes.tooltip }}
        >
          <Button
            justIcon
            round
            simple
            onClick={() => {
              this.syncGroup(group);
            }}
            color="success"
            className="sync"
          >
            <Sync />
          </Button>
        </Tooltip>
        {/* use this button to add a edit kind of action */}
        <Tooltip
          disableFocusListener={true}
          id="tooltip-top"
          title={this.props.t('translation:options')}
          placement="top"
          classes={{ tooltip: this.props.classes.tooltip }}
        >
          <Button
            justIcon
            round
            simple
            onClick={() => {
              this.changeGroupOptionsClick(group);
            }}
            color="warning"
            className="edit"
          >
            <Assignment />
          </Button>
        </Tooltip>
        {/* use this button to remove the data row */}
        <Tooltip
          disableFocusListener={true}
          id="tooltip-top"
          title={this.props.t('translation:delete')}
          placement="top"
          classes={{ tooltip: this.props.classes.tooltip }}
        >
          <Button
            justIcon
            round
            simple
            onClick={() => this.deleteGroupWarning(group)}
            color="danger"
            className="delete"
          >
            <Delete />
          </Button>
        </Tooltip>
      </div>
    );
  }

  changeGroupOptionsEvent(newGroup) {
    // Ara substituim el fitxer de l'array d'estat per tal que el nou nom surti a la pantalla
    //console.log("Hem rebut l'event: " + newGroup);
    this.addGroupLink(newGroup);
    this.addGroupSyncStatus(newGroup);
    this.addGroupActions(newGroup);
    var temp = [...this.state.groups];
    var index = temp.findIndex(x => x._id === newGroup._id);
    temp.splice(index, 1, newGroup);
    if (this._isMounted)
      this.setState({
        groups: temp
      });
  }

  changeGroupOptions(options) {
    //event.preventDefault();
    this.showGroupOptions(false);
    feathersClient
      .service("groups")
      .patch(options._id, {
        name: options.name
      })
      .then(newGroup => {
        this.showNotification(
          this.props.t('translation:new_group_options_submitted_correctly'),
          "success"
        );
      })
      .catch(error => {
        this.showNotification(this.props.t('translation:error') + ": " + error.name, "warning");
      });
  }

  keySort(a, b) {
    return a.key.localeCompare(b.key);
  }

  nameFilter(filter, row) {
    return row._original["name"]
      .toLowerCase()
      .includes(filter.value.toLowerCase());
  }

  syncSort(a, b) {
    const dateA = moment(a.key, defaults.momentFormat);
    const dateB = moment(b.key, defaults.momentFormat);
    if (dateA.isBefore(dateB)) return -1;
    if (dateA.isSame(dateB)) return 0;
    /*    if (moment(dateA, moment.ISO_8601).isBefore(dateB, moment.ISO_8601)) return -1;
    if (moment(dateA, moment.ISO_8601).isSame(dateB, moment.ISO_8601)) return 0;*/
    return 1;
  }

  render() {
    const { classes } = this.props;
    const { t } = this.props;

    return (
      <div>
        {this.state.alert}
        <Snackbars
          place="tc"
          color={this.state.notification.color}
          //icon={AddAlert}
          message={this.state.notification.text}
          open={this.state.notification.visible}
          closeNotification={() => {
            if (this._isMounted)
              this.setState({ "notification.visible": false });
          }}
        //close
        />
        <Dialog
          classes={{
            root:
              this.props.classes.center + " " + this.props.classes.modalRoot,
            paper: this.props.classes.modal
          }}
          TransitionComponent={Transition}
          keepMounted
          open={this.state.groupOptionsDialog}
          onClose={() => this.showGroupOptions(false)}
          aria-labelledby="classic-modal-slide-title"
          aria-describedby="classic-modal-slide-description"
          style={{ textAlign: "center" }}
        >
          <DialogTitle
            id="classic-modal-slide-title"
            disableTypography
            className={classes.modalHeader}
          >
            <h4 className={classes.cardIconTitle}>{t('translation:group_options')}</h4>
          </DialogTitle>
          <DialogContent
            id="classic-modal-slide-description"
            className={classes.modalBody}
          >
            <GridContainer>
              <GridItem xs={12}>
                <CustomInput
                  //success={this.state.registerEmailState === "success"}
                  //error={this.state.registerEmailState === "error"}
                  labelText={t('translation:name')}
                  id="name"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    value: this.state.groupOptions.name,
                    onChange: event =>
                      this.handleGroupOptionChange(event, "name"),
                    type: "text"
                  }}
                />
              </GridItem>
            </GridContainer>
          </DialogContent>
          <DialogActions className={classes.modalFooter}>
            <Button
              simple
              color="success"
              onClick={() =>
                this.applyGroupOptionsClick(this.state.groupOptions)
              }
              className={classes.registerButton}
              xs={3}
            >
              {t('translation:apply')}
            </Button>
          </DialogActions>
        </Dialog>
        <Card>
          <CardHeader color="success" icon>
            <GridContainer>
              <GridItem xs={12} sm={12} md={6}>
                <GridContainer>
                  <GridItem>
                    <CardIcon color="success">
                      <Extension />
                    </CardIcon>
                  </GridItem>
                  <GridItem xs={4}>
                    <h4 className={classes.cardIconTitle}>{t('translation:groups')}</h4>
                  </GridItem>
                </GridContainer>
              </GridItem>
              <GridItem xs={12} sm={12} md={6}>
                <GridContainer justify="flex-end">
                  <GridItem>
                    <Button
                      color="success"
                      simple
                      className={classes.marginRight}
                      onClick={this.syncAllGroups.bind(this)}
                      style={{ maxWidth: "140px" }}
                    >
                      <Sync className={classes.icons} /> {t('translation:synchronize_all')}
                    </Button>
                  </GridItem>
                  <GridItem>
                    <Button
                      color="success"
                      simple
                      className={classes.marginRight}
                      onClick={this.addNewGroupClick}
                      style={{ maxWidth: "140px" }}
                    >
                      <Extension className={classes.icons} /> {t('translation:new_group')}
                    </Button>
                  </GridItem>
                </GridContainer>
              </GridItem>
            </GridContainer>
          </CardHeader>
          <CardBody>
            <ReactTable
              data={this.state.groups}
              filterable
              previousText={this.props.t('translation:previous')}
              nextText={this.props.t('translation:next')}
              loadingText={this.props.t('translation:loading')}
              noDataText={this.props.t('translation:no_rows_found')}
              pageText={this.props.t('translation:page')}
              ofText={this.props.t('translation:of')}
              rowsText={this.props.t('translation:rows')}
              pageJumpText={this.props.t('translation:jump_to_page')}
              rowsSelectorText={this.props.t('translation:rows_per_page')}
              columns={[
                {
                  Header: t('translation:name'),
                  accessor: "link",
                  filterMethod: this.nameFilter,
                  sortMethod: this.keySort
                },
                {
                  Header: t('translation:synchronized'),
                  accessor: "syncStatus",
                  filterable: false,
                  sortMethod: this.syncSort
                },
                {
                  Header: t('translation:actions'),
                  accessor: "actions",
                  sortable: false,
                  filterable: false,
                  minWidth: 185
                }
              ]}
              defaultPageSize={10}
              showPaginationTop
              showPaginationBottom={false}
              className="-striped -highlight"
            />
          </CardBody>
        </Card>
      </div>
    );
  }
}

export default withStyles(groupsStyle)(withTranslation()(Groups));
